var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPageNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right-s-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.7958 9.99924L7.08333 6.28674L8.14383 5.22624L12.9168 9.99924L8.14383 14.7722L7.08333 13.7117L10.7958 9.99924Z",
    fill: "#525866"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPageNext);
export default __webpack_public_path__ + "static/media/icon-page-next.ac98f5a7ba9331cea41afc4a4a8d9fe6.svg";
export { ForwardRef as ReactComponent };